import { render, staticRenderFns } from "./GroupTotal.vue?vue&type=template&id=ea5b056c&scoped=true"
import script from "./GroupTotal.vue?vue&type=script&lang=js"
export * from "./GroupTotal.vue?vue&type=script&lang=js"
import style0 from "./GroupTotal.vue?vue&type=style&index=0&id=ea5b056c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5b056c",
  null
  
)

export default component.exports